import { createFileRoute, redirect } from "@tanstack/react-router";

import { legacyDestinationTarget } from "@/lib/legacy-redirects";

/**
 * Legacy WordPress destination archive `/tour-destination/{destination}/`.
 * Redirects permanently to the matching city landing page, or to the catalog
 * with a useful query when the destination isn't curated.
 */
export const Route = createFileRoute("/tour-destination/$destination")({
  beforeLoad: ({ params }) => {
    const target = legacyDestinationTarget(params.destination);
    if (target.kind === "city") {
      throw redirect({ to: "/tours/$city", params: { city: target.city }, statusCode: 301 });
    }
    throw redirect({
      to: "/tours",
      search: target.q ? { q: target.q } : {},
      statusCode: 301,
    });
  },
});
